<div class="
py-[20px] px-[20px] bg-white rounded-2xl shadow flex-col justify-start items-center gap-4 inline-flex">

  @if(currentTab === 'date') {
  <div
    class="self-stretch pr-4 pt-4 pb-2 border-b border-zinc-900/opacity-10 justify-start items-center gap-2 inline-flex">
    <div class="text-black text-xl font-bold  leading-tight">

      @if(type==='arrival') {

      @if(timeSelector) {
      {{"PARKIFLY.SEARCH.MODAL.HOTEL_ARRIVAL_DATE_HEADING"| transloco}}

      }@else {
      {{"PARKIFLY.SEARCH.MODAL.FLIGHT.ARRIVAL_HEADING"| transloco}}
      }
      }@else {
      @if(timeSelector) {
      {{"PARKIFLY.SEARCH.MODAL.HOTEL_DEPARTURE_DATE_HEADING"| transloco}}
      }@else{
      {{"PARKIFLY.SEARCH.MODAL.FLIGHT.DEPARTURE_HEADING"| transloco}}
      }
      }
    </div>
  </div>
  <mat-calendar class="w-full" [startAt]="selectedDate" [minDate]="minDate" [maxDate]="maxDate"
    [(selected)]="selectedDate" (selectedChange)="selectDate($event)" ngSkipHydration></mat-calendar>

  @if(timeSelector) {
  <button (click)="changeTab('time')" [disabled]="!selectedDate" [ngClass]="{'font-text-[#7E7E7E]' : !selectedDate,
      'bg-[#FFE871]' : !selectedDate,
      'cursor-not-allowed' : !selectedDate,
      'bg-[#FFC700] hover:bg-[#FFD833]' : selectedDate,
      'cursor-pointer' : selectedDate
      
    }" class="
      self-stretch px-8 py-3  rounded justify-center items-center gap-2 inline-flex">
    <div [ngClass]="{'bg-[#FFE871] text-[#4B4A4A]': !selectedDate}" class="text-base font-semibold  leading-normal">
      {{"PARKIFLY.SEARCH.MODAL.CHOOSE_TIME"| transloco}}
    </div>
    <div class="w-5 h-5 justify-center items-center flex">
      <div class="w-5 h-5 relative flex-col justify-start items-start flex">
        <svg [ngClass]="{'fill-[#4B4A4A]': !selectedDate}" width="21" height="20" viewBox="0 0 21 20"
          xmlns="http://www.w3.org/2000/svg">
          <g id="arrow-narrow-right">
            <path id="Vector" fill-rule="evenodd" clip-rule="evenodd"
              d="M12.793 5.29303C12.9805 5.10556 13.2348 5.00024 13.5 5.00024C13.7652 5.00024 14.0195 5.10556 14.207 5.29303L18.207 9.29303C18.3945 9.48056 18.4998 9.73487 18.4998 10C18.4998 10.2652 18.3945 10.5195 18.207 10.707L14.207 14.707C14.0184 14.8892 13.7658 14.99 13.5036 14.9877C13.2414 14.9854 12.9906 14.8803 12.8052 14.6948C12.6198 14.5094 12.5146 14.2586 12.5123 13.9964C12.51 13.7342 12.6108 13.4816 12.793 13.293L15.086 11H3.5C3.23478 11 2.98043 10.8947 2.79289 10.7071C2.60536 10.5196 2.5 10.2652 2.5 10C2.5 9.73481 2.60536 9.48046 2.79289 9.29292C2.98043 9.10539 3.23478 9.00003 3.5 9.00003H15.086L12.793 6.70703C12.6055 6.5195 12.5002 6.26519 12.5002 6.00003C12.5002 5.73487 12.6055 5.48056 12.793 5.29303Z"
              fill="#212529" />
          </g>
        </svg>

      </div>
    </div>
  </button>
  }

  }

  @if(currentTab === 'time' && timeSelector) {
  <div
    class="self-stretch pr-4 pt-4 pb-8 border-b border-zinc-900/opacity-10 justify-start items-center gap-2 inline-flex">
    <div class="text-black text-xl font-bold  leading-tight">

      @if(type==='arrival') {
      {{"PARKIFLY.SEARCH.MODAL.HOTEL_ARRIVAL_TIME_HEADING"| transloco}}
      }@else {
      {{"PARKIFLY.SEARCH.MODAL.HOTEL_DEPARTURE_TIME_HEADING"| transloco}}
      }
    </div>
  </div>
  <div class="self-stretch grow shrink basis-0 flex-col justify-start items-center gap-8 flex">
    <div class="self-stretch h-20 rounded-2xl flex-col justify-center items-center gap-2 flex">
      <!-- hours-->
      <div class="  self-stretch px-2 py-4 bg-stone-50 justify-center items-center gap-1 inline-flex">
        <div [matMenuTriggerFor]="hoursMenu"
          class="cursor-pointer grow shrink basis-0 h-14 justify-center items-center gap-3 flex">
          <div class="text-center text-zinc-900 text-5xl font-medium ">

            {{selectedTime | date : 'HH'}}
          </div>
          <div class="w-4 h-4 relative">
            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.99652 7.64L1.20052 2.158C0.634523 1.513 1.09452 0.5 1.95352 0.5H11.5455C11.7378 0.499836 11.926 0.555088 12.0876 0.659141C12.2493 0.763194 12.3775 0.911637 12.457 1.08669C12.5364 1.26175 12.5637 1.456 12.5356 1.64618C12.5075 1.83636 12.4252 2.01441 12.2985 2.159L7.50252 7.639C7.40866 7.74641 7.29291 7.8325 7.16303 7.89148C7.03316 7.95046 6.89216 7.98098 6.74952 7.98098C6.60688 7.98098 6.46589 7.95046 6.33601 7.89148C6.20614 7.8325 6.09038 7.74641 5.99652 7.639V7.64Z"
                fill="#212529" />
            </svg>

          </div>
        </div>
        <mat-menu class="h-full max-h-80 max-width-initial" #hoursMenu="matMenu">
          @for (item of hours; track $index) {
          <button mat-menu-item (click)="changeHour(item)">
            <span>{{item}}</span>
          </button>
          }
        </mat-menu>

        <!-- minutes -->
        <div class="text-center text-zinc-900 text-base font-normal  leading-none">:</div>
        <div [matMenuTriggerFor]="minutesMenu"
          class="cursor-pointer grow shrink basis-0 h-14 justify-center items-center gap-3 flex">
          <div class="text-center text-zinc-900 text-5xl font-medium ">
            {{selectedTime | date : 'mm'}}
          </div>
          <div class="w-4 h-4 relative">
            <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.99652 7.64L1.20052 2.158C0.634523 1.513 1.09452 0.5 1.95352 0.5H11.5455C11.7378 0.499836 11.926 0.555088 12.0876 0.659141C12.2493 0.763194 12.3775 0.911637 12.457 1.08669C12.5364 1.26175 12.5637 1.456 12.5356 1.64618C12.5075 1.83636 12.4252 2.01441 12.2985 2.159L7.50252 7.639C7.40866 7.74641 7.29291 7.8325 7.16303 7.89148C7.03316 7.95046 6.89216 7.98098 6.74952 7.98098C6.60688 7.98098 6.46589 7.95046 6.33601 7.89148C6.20614 7.8325 6.09038 7.74641 5.99652 7.639V7.64Z"
                fill="#212529" />
            </svg>
          </div>
        </div>
      </div><svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.99652 7.64L1.20052 2.158C0.634523 1.513 1.09452 0.5 1.95352 0.5H11.5455C11.7378 0.499836 11.926 0.555088 12.0876 0.659141C12.2493 0.763194 12.3775 0.911637 12.457 1.08669C12.5364 1.26175 12.5637 1.456 12.5356 1.64618C12.5075 1.83636 12.4252 2.01441 12.2985 2.159L7.50252 7.639C7.40866 7.74641 7.29291 7.8325 7.16303 7.89148C7.03316 7.95046 6.89216 7.98098 6.74952 7.98098C6.60688 7.98098 6.46589 7.95046 6.33601 7.89148C6.20614 7.8325 6.09038 7.74641 5.99652 7.639V7.64Z"
          fill="#212529" />
      </svg>

      <mat-menu #minutesMenu="matMenu">

        @for (item of (type == 'arrival' ? minutesArrival : minutes); track $index) {
        <button mat-menu-item (click)="changeMinute(item)">
          <span>{{item}}</span>
        </button>
        }
      </mat-menu>
    </div>
    <div class="self-stretch h-11 flex-col justify-start items-center gap-8 flex">
      <div class="self-stretch h-11 flex-col justify-start items-start gap-2 flex">
        <div class="text-gray-500 text-base font-normal  leading-none">
          {{"PARKIFLY.SEARCH.ARRIVAL_DAY" | transloco}}
        </div>
        <div class="w-32 h-4 justify-center items-start gap-2 inline-flex">
          <div class="text-center text-black text-base font-normal  leading-none">
            {{ selectedDate | date : 'dd' }}
          </div>
          <div class="text-center text-black text-base font-normal  leading-none">/</div>
          <div class="text-center text-black text-base font-normal  leading-none">
            {{ selectedDate | date : 'MM' }}
          </div>
          <div class="text-center text-black text-base font-normal  leading-none">/</div>
          <div class="text-center text-black text-base font-normal  leading-none">
            {{ selectedDate | date : 'yyyy' }}
          </div>
        </div>
      </div>
    </div>
    <div class="self-stretch h-11 flex-col justify-start items-center gap-8 flex">
      <div class="self-stretch h-11 flex-col justify-start items-start gap-2 flex">
        <div class="text-gray-500 text-base font-normal  leading-none">
          {{"PARKIFLY.SEARCH.ARRIVAL_TIME" | transloco}}

        </div>
        <div class="justify-center items-start gap-2 inline-flex">
          <div class="text-center text-black text-base font-normal  leading-none">

            {{selectedTime | date : 'HH'}}
          </div>
          <div class="text-center text-black text-base font-normal  leading-none">:</div>
          <div class="text-center text-black text-base font-normal  leading-none">

            {{selectedTime | date : 'mm'}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="self-stretch justify-start items-start gap-4 inline-flex">
    <button (click)="changeTab('date')"
      class="grow shrink basis-0 h-12 py-3 rounded justify-center items-center gap-2 flex">
      <div class="w-5 h-5 justify-center items-center flex">
        <div class="w-5 h-5 relative flex-col justify-start items-start flex">
          <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8.20679 14.707C8.01926 14.8945 7.76495 14.9998 7.49979 14.9998C7.23462 14.9998 6.98031 14.8945 6.79279 14.707L2.79279 10.707C2.60532 10.5195 2.5 10.2652 2.5 10C2.5 9.73488 2.60532 9.48057 2.79279 9.29304L6.79279 5.29304C6.98139 5.11088 7.23399 5.01009 7.49619 5.01237C7.75838 5.01465 8.0092 5.11981 8.1946 5.30522C8.38001 5.49063 8.48518 5.74144 8.48746 6.00364C8.48974 6.26584 8.38894 6.51844 8.20679 6.70704L5.91379 9.00004H17.4998C17.765 9.00004 18.0194 9.1054 18.2069 9.29293C18.3944 9.48047 18.4998 9.73482 18.4998 10C18.4998 10.2653 18.3944 10.5196 18.2069 10.7071C18.0194 10.8947 17.765 11 17.4998 11H5.91379L8.20679 13.293C8.39426 13.4806 8.49957 13.7349 8.49957 14C8.49957 14.2652 8.39426 14.5195 8.20679 14.707Z"
              fill="#0040DD" />
          </svg>

        </div>
      </div>
      <div class="
          cursor-pointer
          text-blue-700 text-base font-semibold  leading-normal">
        {{"PARKIFLY.SEARCH.MODAL.CHANGE_DATE" | transloco}}
      </div>
    </button>
    <div (click)="dialogRef.close()"
      class=" cursor-pointer grow shrink basis-0 h-12 px-8 py-3 bg-[#FFC700] hover:bg-[#FFD833] rounded justify-center items-center gap-2 flex">
      <div class="text-neutral-800 text-base font-semibold  leading-normal">
        {{"PARKIFLY.SEARCH.MODAL.DONE" | transloco}}
      </div>
    </div>
  </div>
  }
</div>